import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  // Keep local/dev noise out unless explicitly enabled.
  if (!dsn) return;

  Sentry.init({
    dsn,
    sendDefaultPii: false,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 0,
  });
}

export { Sentry };
